import { __awaiter, __decorate, __generator } from "tslib";
import { observable, makeObservable } from 'mobx';
import { ComplaintSupportRepo } from '../../Repositories/ComplaintSupportRepo';
var ComplaintSupportStore = /** @class */ (function () {
    function ComplaintSupportStore(rootStore) {
        Object.defineProperty(this, "ucfStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "complaintCustomers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintBrands", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintPackagings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintDischarges", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintModelDeliveries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintConformances", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintMedias", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintEnclosed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "questionList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintSales", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintCustomerList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintBrandList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintPackagingList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintDischargeList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintModelDeliveryList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintConformanceList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintMediaList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintEnclosedList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintSalesList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        makeObservable(this);
        this.ucfStore = rootStore;
    }
    Object.defineProperty(ComplaintSupportStore.prototype, "getAllSupportData", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getCustomerList()];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.getBrandList()];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, this.getPackagingList()];
                        case 3:
                            _a.sent();
                            return [4 /*yield*/, this.getModelDeliveryList()];
                        case 4:
                            _a.sent();
                            return [4 /*yield*/, this.getDischargeList()];
                        case 5:
                            _a.sent();
                            return [4 /*yield*/, this.getConformanceList()];
                        case 6:
                            _a.sent();
                            return [4 /*yield*/, this.getComplaintMediaList()];
                        case 7:
                            _a.sent();
                            return [4 /*yield*/, this.getEnclosedList()];
                        case 8:
                            _a.sent();
                            return [4 /*yield*/, this.getSalesList()];
                        case 9:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "getCustomerList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var customers;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintSupportRepo.getCustomerList(this.ucfStore)];
                        case 1:
                            customers = _a.sent();
                            this.complaintCustomers = customers;
                            this.complaintCustomerList = customers.map(function (c) { return ({ value: c.id, label: c.name }); });
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "setSelectedCustomer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            var customer = this.complaintCustomers.find(function (c) { return c.id === id; });
            if (customer) {
                this.ucfStore.complaint.customerInput = {
                    value: customer.id,
                    label: customer.name,
                };
                this.ucfStore.complaint.complaintDetail.customerId = customer.id;
                this.ucfStore.complaint.complaintDetail.customerName = customer.name;
            }
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "getBrandList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var brands;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintSupportRepo.getBrandList(this.ucfStore)];
                        case 1:
                            brands = _a.sent();
                            this.complaintBrands = brands;
                            this.complaintBrandList = brands.map(function (b) { return ({ value: b.id, label: b.name }); });
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "setSelectedBrand", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            var brand = this.complaintBrands.find(function (b) { return b.id === id; });
            if (brand) {
                this.ucfStore.complaint.brandInput = {
                    value: brand.id,
                    label: brand.name,
                };
                this.ucfStore.complaint.complaintDetail.brandId = brand.id;
                this.ucfStore.complaint.complaintDetail.brandName = brand.name;
                this.ucfStore.complaint.complaintDetail.productId = brand.id;
                this.ucfStore.complaint.complaintDetail.productName = brand.name;
                this.ucfStore.complaint.complaintDetail.plantId = brand.plantId;
                this.ucfStore.complaint.complaintDetail.plantName = brand.plantName;
            }
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "getPackagingList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var packaging;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintSupportRepo.getPackagingList(this.ucfStore)];
                        case 1:
                            packaging = _a.sent();
                            this.complaintPackagings = packaging;
                            this.complaintPackagingList = packaging.map(function (p) { return ({ value: p.id, label: p.name }); });
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "setSelectedPackaging", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            var packaging = this.complaintPackagings.find(function (p) { return p.id === id; });
            if (packaging) {
                this.ucfStore.complaint.packagingInput = {
                    value: packaging.id,
                    label: packaging.name,
                };
                this.ucfStore.complaint.complaintDetail.packagingId = packaging.id;
                this.ucfStore.complaint.complaintDetail.packagingName = packaging.name;
            }
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "getDischargeList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var discharge;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintSupportRepo.getDischargeList(this.ucfStore)];
                        case 1:
                            discharge = _a.sent();
                            this.complaintDischarges = discharge;
                            this.complaintDischargeList = discharge.map(function (d) { return ({ value: d.id, label: d.name }); });
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "setSelectedDischarge", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            var discharge = this.complaintDischarges.find(function (d) { return d.id === id; });
            if (discharge) {
                this.ucfStore.complaint.dischargeInput = {
                    value: discharge.id,
                    label: discharge.name,
                };
                this.ucfStore.complaint.complaintDetail.dischargePortId = discharge.id;
                this.ucfStore.complaint.complaintDetail.dischargePortName = discharge.name;
                this.ucfStore.complaint.complaintDetail.countryId = discharge.countryId;
                this.ucfStore.complaint.complaintDetail.countryName = discharge.countryName;
            }
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "getModelDeliveryList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var modelDelivery;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintSupportRepo.getModelDeliveryList(this.ucfStore)];
                        case 1:
                            modelDelivery = _a.sent();
                            this.complaintModelDeliveries = modelDelivery;
                            this.complaintModelDeliveryList = modelDelivery.map(function (m) { return ({ value: m.id, label: m.name }); });
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "setSelectedModel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            var model = this.complaintModelDeliveries.find(function (m) { return m.id === id; });
            if (model) {
                this.ucfStore.complaint.modelInput = {
                    value: model.id,
                    label: model.name,
                };
                this.ucfStore.complaint.complaintDetail.modelOfDeliveryId = model.id;
                this.ucfStore.complaint.complaintDetail.modelOfDeliveryName = model.name;
            }
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "getConformanceList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var conformance;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintSupportRepo.getConformanceList(this.ucfStore)];
                        case 1:
                            conformance = _a.sent();
                            this.complaintConformances = conformance;
                            this.complaintConformanceList = conformance.map(function (c) { return ({ value: c.id, label: c.name }); });
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "setSelectedConformance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id, isEdit) {
            return __awaiter(this, void 0, void 0, function () {
                var conformance;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            conformance = this.complaintConformances.find(function (c) { return c.id === id; });
                            if (!conformance) return [3 /*break*/, 2];
                            this.ucfStore.complaint.conformanceInput = {
                                value: conformance.id,
                                label: conformance.name,
                            };
                            this.ucfStore.complaint.complaintDetail.conformanceTypeId = conformance.id;
                            this.ucfStore.complaint.complaintDetail.conformanceTypeName = conformance.name;
                            if (!!isEdit) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.getQuestionList(conformance.id)];
                        case 1:
                            _a.sent();
                            if (this.questionList.length > 0) {
                                this.ucfStore.complaint.complaintDetail.customerComplaintQuestion = this.questionList;
                            }
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "getComplaintMediaList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var media;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintSupportRepo.getComplaintMediaList(this.ucfStore)];
                        case 1:
                            media = _a.sent();
                            this.complaintMedias = media;
                            this.complaintMediaList = media.map(function (m) { return ({ value: m.id, label: m.name }); });
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "setSelectedMedia", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            var media = this.complaintMedias.find(function (m) { return m.id === id; });
            if (media) {
                this.ucfStore.complaint.mediaInput = {
                    value: media.id,
                    label: media.name,
                };
                this.ucfStore.complaint.complaintDetail.complaintMediaId = media.id;
                this.ucfStore.complaint.complaintDetail.complaintMediaName = media.name;
            }
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "getEnclosedList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var enclosed;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintSupportRepo.getEnclosedList(this.ucfStore)];
                        case 1:
                            enclosed = _a.sent();
                            this.complaintEnclosed = enclosed;
                            this.complaintEnclosedList = enclosed.map(function (e) { return ({ value: e.id, label: e.name }); });
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "setSelectedEnclosed", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            var enclosed = this.complaintEnclosed.find(function (c) { return c.id === id; });
            if (enclosed) {
                this.ucfStore.complaint.enclosedInput = {
                    value: enclosed.id,
                    label: enclosed.name,
                };
                this.ucfStore.complaint.complaintDetail.enclosedId = enclosed.id;
                this.ucfStore.complaint.complaintDetail.enclosedName = enclosed.name;
            }
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "getQuestionList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (conformanceId) {
            return __awaiter(this, void 0, void 0, function () {
                var questions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintSupportRepo.getQuestionList(this.ucfStore, conformanceId)];
                        case 1:
                            questions = _a.sent();
                            this.questionList = questions;
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "getSalesList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var sales;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintSupportRepo.getSalesList(this.ucfStore)];
                        case 1:
                            sales = _a.sent();
                            this.complaintSales = sales;
                            this.complaintSalesList = sales.map(function (c) { return ({ value: c.id, label: c.email + " - " + c.memberName }); });
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportStore.prototype, "setSelectedSales", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            var sales = this.complaintSales.find(function (c) { return c.id === id; });
            if (sales) {
                this.ucfStore.complaint.salesEmailInput = {
                    value: sales.id,
                    label: sales.email + " - " + sales.memberName,
                };
                this.ucfStore.complaint.complaintDetail.salesMemberId = sales.id;
                this.ucfStore.complaint.complaintDetail.salesMemberName = sales.email + " - " + sales.memberName;
            }
        }
    });
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "ucfStore", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintCustomers", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintBrands", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintPackagings", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintDischarges", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintModelDeliveries", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintConformances", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintMedias", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintEnclosed", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "questionList", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintSales", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintCustomerList", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintBrandList", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintPackagingList", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintDischargeList", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintModelDeliveryList", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintConformanceList", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintMediaList", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintEnclosedList", void 0);
    __decorate([
        observable
    ], ComplaintSupportStore.prototype, "complaintSalesList", void 0);
    return ComplaintSupportStore;
}());
export { ComplaintSupportStore };
//# sourceMappingURL=data:application/json;base64,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